import { type LayoutProps } from "./layout";
import { KeyValueObject } from "@components/common/types/general";

export function getSidebarBackgroundColor(layoutTheme: LayoutProps["theme"], theme: any): KeyValueObject | null {
    if (layoutTheme === "light") {
        return {
            backgroundColor: theme.colors.white,
        };
    }
    return {
        backgroundColor: theme.colors.gray[50],
    };
}

export function getSidebarBorder(layoutTheme: LayoutProps["theme"], theme: any): KeyValueObject {
    if (layoutTheme === "light") {
        return { borderLeft: `1px solid ${theme.colors.gray[100]}` };
    }
    return { borderLeft: `1px solid ${theme.colors.gray[50]}` };
}
